import { render } from "./person-legal-update.vue?vue&type=template&id=63670ff0"
import script from "./person-legal-update.vue?vue&type=script&lang=js"
export * from "./person-legal-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__